import { Component, Input, ElementRef, ViewChild, ViewChildren, QueryList,
  OnInit, OnDestroy, AfterViewInit, AfterViewChecked, OnChanges } from '@angular/core';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { MitterService } from '../../../services/mitter.service';
import { NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery';
import { galleryOptions } from '../../utils/gallery-utils';
import { getTimelineEvent } from '../../utils/message-utils';
import { CommonService } from '../../../services/common.service';

const TYPING_INDICATOR_WINDOW = 3000; // 3 seconds

@Component({
  selector: 'mitter-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.css']
})
export class ChannelComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  @Input() channelId: string;
  @Input() mitter: any;
  @Input() userRole: string;
  @Input() liveChannel: any;

  channel: object;
  channelWindowElements: any[];
  participants: object;
  username = 'User';
  ttl: number;
  displayTtl: string;
  isUserActive = true;
  isSomeoneTyping: boolean;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  shouldStickToBottom: boolean = true;
  @ViewChild('channelContent') channelContent: ElementRef;
  @ViewChildren('channelMessages') channelMessages: QueryList<any>;

  private messageReceivedToken: string;
  private timelineReceivedToken: string;
  private userTypingToken: string;
  private channelTimelineReceivedToken: string;
  private typingIndicatorTimeoutKey: any;
 public videochatflag = 0;
  constructor(private route: ActivatedRoute, private router: Router,
    private mitterService: MitterService, private commonService: CommonService) {
     
    }

  ngOnInit() {
    this.galleryOptions = galleryOptions;
    this.getUserDataOfChannel(this.liveChannel.customerExternalId);
    this.channelId && this.mitter && this.getChannelData();
    this.synchMessages();
    this.mitterService.mitter && this.buildChannelWindowElements();
    
    this.mitterService.synchChannelTtl(this.liveChannel.entryPublicId)
      .then(fetchedTtl => {
        this.ttl = Math.round(fetchedTtl as number/1000);
        this.initTimer();
      });

    if (this.liveChannel.channelStatus == "Concluded") {
        this.isUserActive = false;
    }
    window.onfocus = () => {
      this.synchMessages.bind(this)();
    }
    this.getPetcartChatdata(this.liveChannel.mitterChannelId);
  }

  ngOnChanges(changes) {
    if (!this.mitterService) return null;

    if (changes.channelId) {
      // channelId has been changed
      this.getUserDataOfChannel(this.liveChannel.customerExternalId);
      this.getPetcartChatdata(this.liveChannel.mitterChannelId);
      this.channelId && this.getChannelData();
      this.synchMessages();
      this.mitterService.synchChannelTtl(this.liveChannel.entryPublicId)
        .then(fetchedTtl => {
          this.ttl = Math.round(fetchedTtl as number/1000);
        });

      if (this.liveChannel.channelStatus == "Concluded") {
          this.isUserActive = false;
      }
    }
  }
  getPetcartChatdata(mcid) {
    this.commonService.getPetcartchatdata(mcid)
    .subscribe(
      (x) => {
        if (x[0].type == 'video') {
          this.videochatflag = 1;
        } else {
          this.videochatflag = 0;
        }
      });
  }
  initTimer() {
    setTimeout(() => {
      this.ttl = this.ttl - 1;

      var date = new Date(null);
      date.setSeconds(this.ttl);
      this.displayTtl = date.toISOString().substr(14, 5);

      if (this.ttl != 0) this.initTimer();
    }, 1000);
  }

  synchMessages() {
    this.channelId && this.mitter && this.mitter.getAllMessagesForChannel(this.channelId);
  }

  getChannelData() {
    this.mitter.getChannelAsync(this.channelId)
      .then(channel => {
        this.channel = channel;
        if (this.liveChannel.channelStatus === "Started" &&
            !this.mitterService.doesJoinChannelEventExist(channel)) {
          const readTimeEvent = getTimelineEvent("com.petcart.channel.JoinChannel", this.mitter.getUserId());
          this.mitter.sendTimelineEventAsync(this.channelId, null, readTimeEvent);
        }
        return channel;
      })
      .then(channel => {
        this.buildChannelWindowElements();
        this.setupGallery();
        return channel;
      });

    this.messageReceivedToken = this.mitter.onMessageReceived((channelId, message) => {
      if (this.channelId === channelId) {
        this.buildChannelWindowElements();
      }
    });

    this.timelineReceivedToken = this.mitter.onTimelineEventReceived((channelId, messageId, timelineEvent) => {
      if (this.channelId === channelId) {
        this.buildChannelWindowElements();
      }
    });

    this.channelTimelineReceivedToken = this.mitter.onChannelTimelineEventReceived((channelId, timelineEvent) => {
      if (this.channelId === channelId) {
        this.buildChannelWindowElements();
      }
    })

    this.userTypingToken = this.mitter.onStreamDataReceived((channelId, streamData) => {
      if (this.channelId === channelId && streamData.context === "typing-in-progress"
          && streamData.senderId.identifier !== this.mitter.getUserId()) {
        this.refreshTypingIndicator();
      }
    });
  }

  refreshTypingIndicator() {
    this.typingIndicatorTimeoutKey && clearTimeout(this.typingIndicatorTimeoutKey);
    this.isSomeoneTyping = true;

    this.typingIndicatorTimeoutKey = setTimeout(() => {
      this.isSomeoneTyping = false;
      this.typingIndicatorTimeoutKey = null;
    }, 3000);
  }

  ngAfterViewChecked() {
    let target = this.channelContent.nativeElement;
    this.shouldStickToBottom = target.scrollTop === target.scrollHeight - target.clientHeight;
  }

  ngAfterViewInit() {
    let ChannelWindow = this;
    this.channelMessages.changes.subscribe(() => {
      let target = ChannelWindow.channelContent.nativeElement;
      if (ChannelWindow.shouldStickToBottom) {
        target.scrollTop = target.scrollHeight - target.clientHeight;
      }
    });
  }

  buildChannelWindowElements() {
    this.channel = this.mitterService.mitter.getChannel(this.liveChannel.mitterChannelId);
    var mergedArray = this.mitterService.mitter.getMessagesForChannel(this.liveChannel.mitterChannelId)
                        .concat((this.channel['timelineEvents'] || []).filter(e => e.type === 'com.petcart.channel.JoinChannel'));
    this.channelWindowElements = mergedArray.sort((e1, e2) => {
      if (e1.eventTimeMs) {
        if (e2.eventTimeMs)
          return e1.eventTimeMs - e2.eventTimeMs;
        else
          return e1.eventTimeMs - this.mitterService.getSentTime(e2);
      } else {
        if (e2.eventTimeMs)
          return this.mitterService.getSentTime(e1) - e2.eventTimeMs;
        else
          return this.mitterService.getSentTime(e1) - this.mitterService.getSentTime(e2);
      }
    });
    this.setupGallery();
  }


  isMessage(channelWindowElement) {
    return channelWindowElement.timelineEvents != null;
  }

  setupGallery() {
    this.galleryImages = this.channelWindowElements
      .filter(e => this.isMessage(e))
      .filter((m: any) => m.payloadType === 'mitter.mt.Image')
      .map((m: any) => {
        let baseImageUrl = this.mitter.getMitterUrl() +
          m.messageData.find(d => d.dataType === 'text/uri-list').data.link;

        return {
          small: baseImageUrl.replace('$repr', 'base'),
          medium: baseImageUrl.replace('$repr', 'base'),
          big: baseImageUrl.replace('$repr', 'base')
        };
      });
  }

  openVideoChat() {
    this.router.navigate(["/chats", this.channelId, "videochat"]);
  }
  getUserDataOfChannel(customerExternalId) {
    this.commonService.getAppointmentmentUserDetail(customerExternalId)
    .subscribe(
        (x) => {
            this.username = x[0].name;
        }
    );
}


  ngOnDestroy() {
    this.mitter.removeOnMessageReceived(this.messageReceivedToken);
    this.mitter.removeOnTimelineEventReceived(this.timelineReceivedToken);
    this.mitter.removeOnChannelTimelineEventReceived(this.channelTimelineReceivedToken);
  }
}
